import { Box, Button, Stack, TextField, Typography } from "@mui/material";
import { useEffect, useState } from "react";
import { useHttpClientContext } from "../contexts/HttpClientContext";
import { useAuthContext } from "../contexts/AuthContext";

import { AxiosError } from "axios";
import { useTranslation } from "react-i18next";

//import "./NotificationTestPage.css";

const NotificationTestPage = () => {
    const httpClientContext = useHttpClientContext();
    const authContext = useAuthContext();
    const { t } = useTranslation();

    const [memershipNumber, setMembershipNumber] = useState("");
    const [eventId, setEventId] = useState("");
    useEffect(() => {

        //TODO: check why we need this one ...
        if (httpClientContext.authenticatedClientReady) {
            authContext.user.match({
                loggedIn(user) {
                    if (!user.isInternalTester()) {
                        window.location.href = "/";
                        return;
                    }
                }
            })
        }
    }, [httpClientContext.authenticatedClientReady]);


    const convertBase64UrlToBase64 = (base64url: string) => {
        base64url = base64url
            .replace(/-/g, '+')
            .replace(/_/g, '/');

        var pad = base64url.length % 4;
        if (pad) {
            if (pad === 1) {
                throw new Error('InvalidLengthError: Input base64url string is the wrong length to determine padding');
            }
            base64url += new Array(5 - pad).join('=');
        }

        return base64url;
    }

    const base64UrlToArrayBuffer = (base64url: string) => {
        const base64 = convertBase64UrlToBase64(base64url);
        var binaryString = atob(base64);
        var bytes = new Uint8Array(binaryString.length);
        for (var i = 0; i < binaryString.length; i++) {
            bytes[i] = binaryString.charCodeAt(i);
        }
        return bytes.buffer;
    }
    const pushAvaialble = () => "serviceWorker" in navigator &&
        "PushManager" in window &&
        "Notification" in window &&
        // modern browsers || safari
        (window.matchMedia("(display-mode: standalone)").matches || (window.navigator as any).standalone === true);

    const registerDevice = async () => {

        if (!pushAvaialble()) {
            alert("Enheten stödjer inte push notifikationer. Registrera en enhet som har sidan sparad på hemskärmen som en webbapp.");
            return;
        }

        if ("serviceWorker" in navigator && "PushManager" in window) {
            const reg = await navigator.serviceWorker.ready;

            const subscription = await reg.pushManager.subscribe({
                userVisibleOnly: true,
                applicationServerKey: base64UrlToArrayBuffer("BJdMwXkpLFhbooP4D5xYe9Ei0LEX0IF4apm_hm8yrQ19o05fLTrGOOnvUUjg4X-TnFgahz3O5BbkX0nYoS32H5E")
            });


            console.log(subscription);
            //setTestString(JSON.stringify(subscription));

            httpClientContext.authenticatedHttpClient.post("web-push/subscribe", {
                "subscription": subscription
            })
                .then(data => {
                    alert("Enheten är nu registrerad!");
                    console.log("Successfully subscribed", data);
                })
                .catch((error: AxiosError) => {
                    if (error.status === 400) {
                        alert("Enheten är redan registrerad!");

                    } else {
                        alert("Ett fel har inträffat.");
                    }
                    console.error("Error subscring", error);
                })
        } else {
            alert("WebPush stödjs inte av denna enhet.");
        }
    }

    return (
        <Box m={2}>
            <Box p={2}>
                <Typography variant="h4">{t("notification_test.title")}</Typography>
                <p>{t("notification_test.step_1")}</p>
                <p>{t("notification_test.step_2")}</p>
                <p>{t("notification_test.info_1")}</p>
                <p>{t("notification_test.info_2")}</p>
            </Box>
            <Box p={2}>
                <Button variant="contained" onClick={registerDevice}>{t("notification_test.register_device")}</Button>
            </Box>
            <Box p={2} sx={{ width: 'auto', display: 'inline-block' }}>
                <Stack>
                    <TextField
                        sx={{ marginBottom: 2 }}
                        value={memershipNumber}
                        type="text"
                        label={t("notification_test.membership_number")}
                        onChange={evt => setMembershipNumber(evt.target.value)}
                    />
                    <TextField
                        sx={{ marginBottom: 2 }}
                        value={eventId}
                        type="text"
                        label={t("notification_test.event_id_optional")}
                        onChange={evt => setEventId(evt.target.value)}
                    />
                    <Button variant="contained" onClick={() => {
                        if (!memershipNumber.length) {
                            alert("Välj ett medlemsnummer!")
                            return;
                        }

                        const payload: { membership_number: string; event_id?: string } = {
                            membership_number: memershipNumber
                        };
                        if (eventId.length) {
                            payload.event_id = eventId;
                        }

                        httpClientContext.authenticatedHttpClient.post("/web-push/send-test", payload)
                            .then(() => {
                                alert("Notis skickad!");
                            })
                            .catch((error: AxiosError) => {

                                if (error.status === 404) {
                                    alert("Medlemsnumret har ingen enhet registrerad.");

                                } else if (error.status === 403) {
                                    alert("Behörighet saknas.");

                                } else {
                                    alert("Ett fel har inträffat!");
                                }
                            });
                    }}>{t("notification_test.send_notification")}</Button>
                </Stack>
            </Box>
        </Box>
    );
}

export default NotificationTestPage;